/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "倒计时",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "time_text",
                name: "开头文本",
                type: "text"
            },
            {
                key: "time_number",
                name: "时间",
                type: "date-picker-box"
            },
            {
                key: "icon_url",
                name: "背景样式",
                type: "img",
                tip: "建议尺寸：750*96px"
            },
            {
                key: "text_color",
                name: "字体颜色",
                type: "color"
            },
            {
                key: "background_color",
                name: "背景颜色",
                type: "color"
            },
            {
                key: "time_color",
                name: "时间底色",
                type: "color"
            }
        ]
    }
];
export default config;